ga('create', 'UA-20449778-2', 'afvalonline.nl');
ga('send', 'pageview');
